import { render } from "./PlatformManagement.vue?vue&type=template&id=c7eaed70&scoped=true"
import script from "./PlatformManagement.vue?vue&type=script&lang=js"
export * from "./PlatformManagement.vue?vue&type=script&lang=js"

import "./PlatformManagement.vue?vue&type=style&index=0&id=c7eaed70&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c7eaed70"]])

export default __exports__